import React, {useState} from 'react';
import UniversalTable from '../UniversalTable/UniversalTable';
import {createPortal} from 'react-dom';
import CreateDepartment from '../CreateDepartment/CreateDepartment';
import WorkplacesTab from '../WorkplacesTab/WorkplacesTab';
import DepartmentChildren from '../DepartmentChildren/DepartmentChildren'; // Рекурсивный компонент для вложенных департаментов

const DepartmentTab = ({
  dataList,
  handleContextMenu,
  selectedItems,
  activePopup,
  handleSelectedPopup,
  selectedItemId,
  updateTabData,
  selectedTab,
  onSelectItem,
  deleteError,
  handleTypeActionClear,
  menuTarget,
}) => {
  const [expandedRow, setExpandedRow] = useState(null);

  const columns = [
    {key: 'number', title: '№'},
    {key: 'name', title: 'Наименование'},
  ];
  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
      handleTypeActionClear();
    } else {
      setExpandedRow(rowId);
    }
  };

  // Функция для обновления данных конкретного отдела
  const updateDepartmentData = () => {
    updateTabData(selectedTab); // Обновляем данные для всей вкладки
  };

  // Данные с учётом рабочих мест и дочерних департаментов
  const data = dataList.map((item) => ({
    ...item,
    children: (
      <>
        {/* Если есть рабочие места, отображаем их */}

        <WorkplacesTab
          dataList={
            item?.workplaces?.length > 0
              ? item.workplaces.map((wp, i) => ({...wp, number: i + 1}))
              : []
          }
          handleContextMenu={handleContextMenu}
          selectedItems={selectedItems}
          selectedItemId={selectedItemId}
          expandedRow={expandedRow}
          updateDepartmentData={updateDepartmentData}
          selectedTab={selectedTab}
          onSelectItem={onSelectItem}
          deleteError={deleteError}
          handleTypeActionClear={handleTypeActionClear}
        />

        {/* Если есть дочерние департаменты, рекурсивно их отображаем */}
        {item.children && (
          <DepartmentChildren
            childrenData={
              item?.children?.length > 0
                ? item.children.map((ch, i) => ({...ch, number: i + 1}))
                : []
            }
            expandedRow={expandedRow}
            handleContextMenu={handleContextMenu}
            selectedItems={selectedItems}
            selectedItemId={selectedItemId}
            onSelectItem={onSelectItem}
            parentDepartmentId={item.id}
            updateDepartmentData={updateDepartmentData}
            deleteError={deleteError}
            handleTypeActionClear={handleTypeActionClear}
            menuTarget={menuTarget}
          />
        )}
      </>
    ),
  }));

  return (
    <div className='department-tab'>
      <div className='workplaces-tab__header'>
        <h3 className='workplaces-tab__title'>Подразделения</h3>
      </div>
      <UniversalTable
        data={data}
        columns={columns}
        handleContextMenu={handleContextMenu}
        selectedItems={selectedItems}
        expandedRow={expandedRow}
        onRowClick={handleRowClick}
        onSelectItem={onSelectItem}
        deleteError={deleteError}
        menuTarget={menuTarget}
      />
      {createPortal(
        <CreateDepartment
          isDepartmentFormOpen={activePopup}
          handleClose={() => handleSelectedPopup(false)}
          selectedItemId={selectedItemId}
          updateDepartmentData={updateDepartmentData}
        />,
        document.body
      )}
    </div>
  );
};

export default DepartmentTab;
